import React from 'react';
import { ExternalLink, Github } from 'lucide-react';
import { projects } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const Projects = () => {
  return (
    <section id="projects" className="py-20 bg-[#121214]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Featured <span className="text-[#f97316]">Projects</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#f97316] to-[#10b981] mx-auto mb-4"></div>
            <p className="text-[#a3a3a3] max-w-2xl mx-auto">
              A showcase of my recent work and personal projects demonstrating my skills and passion for development
            </p>
          </div>

          {/* Projects Grid */}
          <div className="grid md:grid-cols-2 gap-8">
            {projects.map((project, index) => (
              <Card
                key={project.id}
                className="bg-[#0a0a0b] border-[#1f1f23] hover:border-[#f97316] transition-all duration-300 overflow-hidden group"
              >
                {/* Project Image */}
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0b] via-transparent to-transparent opacity-60"></div>
                  
                  {/* Overlay on hover */}
                  <div className="absolute inset-0 bg-[#0a0a0b]/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center gap-4">
                    <Button
                      onClick={() => window.open(project.github, '_blank')}
                      size="sm"
                      className="bg-[#10b981] hover:bg-[#059669] text-white"
                    >
                      <Github size={16} className="mr-2" />
                      Code
                    </Button>
                    <Button
                      onClick={() => window.open(project.demo, '_blank')}
                      size="sm"
                      variant="outline"
                      className="border-[#06b6d4] text-[#06b6d4] hover:bg-[#06b6d4] hover:text-white"
                    >
                      <ExternalLink size={16} className="mr-2" />
                      Demo
                    </Button>
                  </div>
                </div>

                <CardContent className="p-6">
                  <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-[#f97316] transition-colors duration-300">
                    {project.title}
                  </h3>
                  <p className="text-[#a3a3a3] mb-4 line-clamp-3">
                    {project.description}
                  </p>

                  {/* Technologies */}
                  <div className="flex flex-wrap gap-2">
                    {project.technologies.map((tech) => (
                      <Badge
                        key={tech}
                        variant="outline"
                        className="border-[#1f1f23] text-[#10b981] hover:border-[#10b981]"
                      >
                        {tech}
                      </Badge>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Call to Action */}
          <div className="text-center mt-12">
            <p className="text-[#a3a3a3] mb-6">
              Want to see more? Check out my GitHub for additional projects and contributions.
            </p>
            <Button
              onClick={() => window.open('https://github.com/adityayadav', '_blank')}
              className="bg-[#10b981] hover:bg-[#059669] text-white px-8"
            >
              <Github size={18} className="mr-2" />
              View More on GitHub
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
